export default {
    'menu.winner': 'Winner'
};
